<p>base-dialog works!</p>
